'use client';

import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { Chip } from '@packages/shared/src/ui/Chip/Chip';

export const ScrollTopButtonBase = ({ onAfterClick }: { onAfterClick?: () => void }) => {
  const { formatMessage } = useIntl();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // remove if A/B test is finished
    if (onAfterClick) {
      onAfterClick();
    }
  };

  return (
    <Chip
      className="text-[13px] shadow-md"
      iconPosition="start"
      iconClassName="icon-emp-arrow-medium-up mx-0.5"
      onClick={scrollToTop}
      label={formatMessage({
        id: 'scrollToTopButton',
        defaultMessage: 'Nach oben',
      })}
    />
  );
};

export const ScrollTopButton = ({ onAfterClick }: { onAfterClick?: () => void }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          setShow(window.pageYOffset > window.innerHeight);
          ticking = false;
        });
        ticking = true;
      }
    };

    // Check initial scroll position
    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`transition-opacity duration-300 ${show ? 'opacity-100' : 'pointer-events-none opacity-0'}`}
    >
      <ScrollTopButtonBase onAfterClick={onAfterClick} />
    </div>
  );
};

// eslint-disable-next-line import-x/no-default-export
export default ScrollTopButton;
